module.exports = __webpack_public_path__ + "media/images/flags/64/Vatican-City-adef7bfde265b48ae9df83c3b69132d5.png";